import { ACTIONS, COOKIES, APPINDICATORS } from '../constants';
import ERRORTYPES from '../constants/errorTypes';
import createFreeUser from '../utils/userCreation';
import createRequest from '../utils/requestService';
import { integrations, pushGTM } from '../utils/Analytics';
import { isPackageFree } from '../utils/displayHelpers';
import { validateEmail, validateUsername, validatePassword, validateConfirmPassword } from '../utils/formInput';
import { setCookieWithDomain } from '../utils/cookieHelpers';
import accountTypes from '../constants/accountTypes';

const serviceDownError = (error, dispatch) => {
  console.log('error: ', error);
  dispatch({ type: ACTIONS.CREATE_USER_ERROR });
  dispatch({
    type: APPINDICATORS.DISPLAY_ALERT,
    alertType: APPINDICATORS.ALERT_TYPES.DANGER,
    alertText: APPINDICATORS.ALERT_TEXT.USER_CREATION_ERROR,
  });
};

const displayUserCreationSuccessBanner = (dispatch) => {
  dispatch({
    type: APPINDICATORS.DISPLAY_ALERT,
    alertType: APPINDICATORS.ALERT_TYPES.SUCCESS,
    alertText: APPINDICATORS.ALERT_TEXT.USER_CREATION_SUCCESS,
  });
};

export const setUsername = username => ({ type: ACTIONS.SET_USERNAME, username });

export const setPassword = password => ({ type: ACTIONS.SET_PASSWORD, password });

export const toggleTos = () => ({ type: ACTIONS.TOGGLE_TOS });

export const blurPassword = password => (dispatch, getState) => {
  const responsePassword =
    validatePassword(
      password,
      getState().formInputs.confirmPassword_value,
      getState().formInputs.username_value,
    );
  if (responsePassword.isValid) {
    window.analytics.track('Password complete');
  }
};

export const setConfirmPassword = confirmPassword => ({
  type: ACTIONS.SET_CONFIRM_PASSWORD,
  confirmPassword,
});

export const blurConfirmPassword = confirmPassword => (dispatch, getState) => {
  const responsePassword =
    validateConfirmPassword(
      confirmPassword,
      getState().formInputs.password_value,
    );
  if (responsePassword.isValid) {
    window.analytics.track('Confirm password complete');
  }
};

export const setEmail = email => ({ type: ACTIONS.SET_EMAIL, email });

export const blurEmail = email => () => {
  const responseEmail = validateEmail(email);
  if (responseEmail.isValid) {
    window.analytics.track('Email complete');
  }
};

export const usernameExistsCheck = username => (dispatch) => {
  if (!validateUsername(username).isValid) {
    return dispatch({
      type: ACTIONS.USERNAME_EXISTS_CHECK,
      username_unique_value: '',
      username_unique_isValid: false,
      username_unique_errorType: `${ERRORTYPES.USERNAME_PREFIX}${ERRORTYPES.USERNAME_DEFAULT}`,
    });
  }
  window.analytics.track('Username complete');
  return fetch(createRequest(
    `/v3/public/signup/username/${username}`,
    { method: 'GET' },
  ))
    .then((response) => {
      switch (response.status) {
        case 404:
          return {
            isValid: true,
            errorType: ERRORTYPES.USERNAME_AVAILABLE,
            username,
          };

        case 429:
          return {
            isValid: false,
            errorType: ERRORTYPES.USERNAME_TOO_MANY_REQUESTS,
            username,
          };

        case 204:
          return {
            isValid: false,
            errorType: ERRORTYPES.USERNAME_TAKEN,
            username,
          };

        default:
          return {
            isValid: false,
            errorType: ERRORTYPES.USERNAME_DEFAULT,
            username,
          };
      }
    })
    .then((response) => {
      dispatch({
        type: ACTIONS.USERNAME_EXISTS_CHECK,
        username_unique_value: username,
        username_unique_isValid: response.isValid,
        username_unique_errorType: response.errorType,
      });
      return response;
    }).catch((error) => {
      serviceDownError(error, dispatch);
    });
};

const handleAnalyticsAndCookies = (response, userValues, activePackage, activeIsFree) => {
  if (window.analytics) {
    window.analytics.track('Username and password created');
    window.analytics.identify(response.user_id, {
      email: userValues.email,
      username: userValues.username,
      package: activePackage.id,
    }, integrations);
  }

  if (window.ga) {
    window.ga('send', 'event', 'signup_cge', 'user_created', activeIsFree ? 'free' : 'paid');
  }

  setCookieWithDomain(COOKIES.MAKO_AUTH, response.authorization_token);

  // google tag manager
  pushGTM(response.user_id, userValues.email, activePackage);
};

export const createUser = (userValues, activePackage, activeIsFree, history) =>
  async (dispatch) => {
    dispatch({ type: APPINDICATORS.PAGE_LOADING });
    const usernameReq = await usernameExistsCheck(userValues.username)(dispatch);
    if (usernameReq && usernameReq.isValid) {
      return createFreeUser(userValues, activePackage)
        .then((response) => {
          if (response.signup_session_token) {
            handleAnalyticsAndCookies(response, userValues, activePackage, activeIsFree);

            dispatch({ type: ACTIONS.CREATE_USER_SUCCESS });

            if (activePackage.name && activePackage.name.toLowerCase() === accountTypes.ads) {
              history.push('/ads/billing');
            } else if (!isPackageFree(activePackage.id)) {
              history.push('/billing');
            } else {
              displayUserCreationSuccessBanner(dispatch);
              history.push('/account_details');
            }
          } else {
            dispatch({ type: ACTIONS.CREATE_USER_ERROR });
            dispatch({
              type: APPINDICATORS.DISPLAY_ALERT,
              alertType: APPINDICATORS.ALERT_TYPES.DANGER,
              alertText: response.errorText ?
                response.errorText :
                APPINDICATORS.ALERT_TEXT.USER_CREATION_ERROR,
            });
          }
          dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });
        })
        .catch((error) => {
          serviceDownError(error, dispatch);
        });
    }
    dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });
    return null;
  };




// WEBPACK FOOTER //
// ./src/actions/formInputs.js